<template>
  <RestaurantElistmentForm :typeEndPoint="'restaurantElistmentShow'" :dataParams="this.$route.params" />
</template>
<script>
import RestaurantElistmentForm from '@/components/modules/restaurant/enlistment/form'
export default {
  name: 'RestaurantElistmentEdit',
  components: {
    RestaurantElistmentForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/enlistment/edit.vue